// Single source of truth for follow-up worklist status math, shared by the
// /followups page and the nav-button due-count badge so the two can never drift.

export type FollowupStatus = 'done' | 'overdue' | 'due' | 'scheduled';
export type FollowupArm = 'pregnancy' | 'preconception';

export const WEEK_MS = 7 * 24 * 3600 * 1000;

// Extension cohort opens 1 Jul 2026. The worklist (and the badge) default to
// this window so the ~188 pre-existing parent-study cases don't count as
// "overdue". ISO date strings compare lexicographically, so a plain string
// compare against created_at is correct.
export const EXTENSION_START = '2026-07-01';

export function deriveStatus(createdAt: string, hasFollowup: boolean): FollowupStatus {
  if (hasFollowup) return 'done';
  const created = new Date(createdAt).getTime();
  const now = Date.now();
  if (now > created + 8 * WEEK_MS) return 'overdue';
  if (now >= created + 4 * WEEK_MS) return 'due';
  return 'scheduled';
}

// Per-arm table names used by both the page and the badge query.
export const followupArmTables = {
  pregnancy: {
    cases: 'clinical_cases',
    clinicianResponses: 'clinician_responses',
    followups: 'followup_results',
  },
  preconception: {
    cases: 'preconception_cases',
    clinicianResponses: 'preconception_clinician_responses',
    followups: 'preconception_followup_results',
  },
} as const;
